import Vue from 'vue';
import Router from 'vue-router';
import Home from '../components/home/Home';
import Events from '../components/events/Events';
import EventDetail from '../components/events/eventDetail/EventDetail';
import BookingSteps from '../components/bookingSteps/BookingSteps';
import Organiser from '../components/organiser/Organiser';
import OrganiserOverview from '../components/organiser/OrganiserOverview/OrganiserOverview';
import Account from '../components/account/Account';
import Advantages from '../components/advantages/Advantages';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      alias: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
      props: (route) => ({
        category: route.query.category,
        date: route.query.date
      })
    },
    {
      path: '/event/:uuid',
      name: 'EventDetail',
      component: EventDetail
    },
    {
      path: '/booking',
      name: 'BookingSteps',
      component: BookingSteps
    },
    {
      path: '/organisers',
      name: 'OrganiserOverview',
      component: OrganiserOverview
    },
    {
      path: '/organiser/:uuid',
      name: 'Organiser',
      component: Organiser
    },
    {
      path: '/advantages',
      name: 'Advantages',
      component: Advantages
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (window.hasOwnProperty('parentIFrame')) {
      window.parentIFrame.scrollTo(0, 0);
    }

    return { x: 0, y: 0 };
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/apps/booking/router/index.js